<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="开始日期"
              v-model="form.startTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
          <el-col
            class="line"
            :span="1"
          >-</el-col>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="结束日期"
              v-model="form.endTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- <SelectInput
        v-model="searchValue"
        :dbclickFlag="false"
        :showGroup="false"
        style="margin: 20px"
      /> -->
      围栏名称:
      <el-input class="path-name margin-right" v-model="form.pathName" placeholder="围栏名称" />
      围栏类型:
      <el-select v-model="form.status" class="margin-right">
        <el-option label="全部" value=""></el-option>
        <el-option label="进围栏" :value="1"></el-option>
        <el-option label="出围栏" :value="0"></el-option>
      </el-select>
      <!-- <el-select v-model="form.pathType">
        <el-option label="全部" value=""></el-option>
        <el-option label="政府部门" :value="1"></el-option>
        <el-option label="机场" :value="2"></el-option>
        <el-option label="火车站" :value="3"></el-option>
        <el-option label="客运站" :value="4"></el-option>
      </el-select> -->
      <el-button
        style="margin-left: 32px"
        size="small"
        type="primary"
        @click="getData()"
      >查询</el-button>
      <el-button
        style="margin-left: auto"
        size="small"
        type="primary"
        @click="onTip"
      >功能说明</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onOpenForm(null)"
      >新增</el-button>
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="pathName"
          label="围栏名称"
          min-width="160"
          align="center"
        />
        <el-table-column
          prop="statusName"
          label="围栏类型"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="settingTime"
          label="设置报警时间"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="regionShapeName"
          label="围栏形状"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="radius"
          label="半径（km）"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="enabled"
          label="是否启用"
          align="center"
          min-width="180"
          v-slot="{ row }"
        >
          <span>{{ row.enabled == 1 ? '启用' : '未启用'  }}</span>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="operate"
          label="操作"
          align="center"
          min-width="240"
          v-slot="{ row }"
          fixed="right"
        >
          <el-button type="text" size="small" @click="onViewBind(row.pathId)">查看车辆</el-button>
          <el-button type="text" size="small" @click="onBindOperate(row.pathId)">绑定车辆</el-button>
          <el-button type="text" size="small" @click="onOpenUp(row)">{{ row.enabled == 1 ? '禁用' : '启用' }}</el-button>
          <el-button type="text" size="small" @click="onOpenForm(row.pathId)">修改</el-button>
          <el-button type="text" size="small" @click="onDel(row.pathId)">删除</el-button>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getData"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
    <template slot="plugins">
      <FenceForm :visible.sync="fenceFormShow" :pathId="pathId" @onSuccess="currentChange(1)" />
      <BindList :visible.sync="bindVisible" :pathId="pathId" />
      <BindOperate :visible.sync="bindOperateVisible" :pathId="pathId" />
    </template>
  </ManageBox>
</template>

<script>
import day from "dayjs";
import ManageBox from "@/components/ManageBox/index.vue";
// import SelectInput from "@/components/SelectInput/index.vue";
import FenceForm from './components/FenceForm.vue';
import BindList from './components/BindList.vue';
import BindOperate from './components/BindOperate.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ManageBox,
    // SelectInput,
    FenceForm,
    BindList,
    BindOperate
  },
  data() {
    return {
      loading: false,
      fenceFormShow:false,
      bindVisible:false,
      bindOperateVisible:false,
      form: {
        pathName:'',
        status:'',
        pathType:'',
        startTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59:0"),
        dayBeginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        )
      },
      searchValue: null,
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0,
      pathId:null
    };
  },
  computed:{
      ...mapState(['USER']),
  },
  created(){
    this.getData();
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
  },

  methods: {
    //提示弹框
    onTip(){
      this.$msgBox.confirm(`进出区域报警功能介绍：用户通过在地图上绘制区域，并设置报警时间和绑定对应的车辆，当车辆进入或者离开区域，就会触发报警。`, '功能说明', {
        confirmButtonText: '关闭',
        cancelButtonText: '取消',
        type: 'success'
      }).then(async () => {

      }).catch(() => {

      });
    },
    // 操作绑定数据
    onBindOperate(pathId){
      this.pathId = pathId;
      this.bindOperateVisible = true;
    },
    // 查看绑定数据
    onViewBind(pathId){
      this.pathId = pathId;
      this.bindVisible = true;
    },
    // 打开表单
    onOpenForm(pathId){
      this.pathId = pathId;
      this.fenceFormShow = true;
    },
    // 删除
    async onDel(pathId){
      this.$msgBox.confirm(`是否确认删除该围栏?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try{
          const { msg, code } = await this.$API.deletePathInfo({ pathId });
          if(code !== 0) throw { msg };
          this.$msg({
            type:'success',
            message:'删除成功'
          });
          this.getData();
        }catch(err){
          this.$msg({
            type:'error',
            message:err.msg
          });
        }
      }).catch(() => {

      });
    },
    // 启用禁用
    onOpenUp(row){
      this.$msgBox.confirm(`是否确认${row.enabled == 1 ? '禁用' : '启用'}该围栏?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try{
          const { msg, code } = await this.$API.updateAreaEnable({ pathId:row.pathId, enabled: row.enabled == 1 ? 2 : 1 });
          if(code !== 0) throw { msg };
          this.$msg({
            type:'success',
            message:'操作成功'
          });
          this.getData();
        }catch(err){
          this.$msg({
            type:'error',
            message:err.msg
          });
        }
      }).catch(() => {

      });
    },
    currentChange (val) {
      this.currentPage = val;
      this.getData();
    },
    //获取数据
    async getData() {
      let params = {
        startTime: day(this.form.startTime).format(
          "YYYY-MM-DD HH:mm:ss:0"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss:999"
        ),
        childFlag:1,
        enabled:'',
        pathName:this.form.pathName,
        status:this.form.status,
        pathType:this.form.pathType,
        pageSize:this.pageSize,
        pageNumber:this.currentPage
      };
      if (this.form.startTime > this.form.endTime) {
        this.$msg({
          showClose: true,
          message: "开始时间不能大于结束时间!",
          type: "error"
        });
        return;
      }
      // if (this.searchValue) {
      //   params.list = this.searchValue.terminalNo;
      // }
      this.getParams = params;
      try {
        this.loading = true;
        const { data, total } = await this.$API.listPathInfo(params);
        this.total = total;
        this.tableData = data.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        console.log(this.tableData)
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-pagination {
//   padding-top: 20px;
// }
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 420px;
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
.path-name{
  width: 140px;

}
.margin-right{
  margin-right: 10px;
}
</style>
